export default __webpack_public_path__ + "static/media/help-rav-inv-8.dd89e25e.png";